import { render, staticRenderFns } from "./WebsitePublicPlaceListScreen.vue?vue&type=template&id=a36cca98&scoped=true&lang=pug"
import script from "./WebsitePublicPlaceListScreen.vue?vue&type=script&lang=ts"
export * from "./WebsitePublicPlaceListScreen.vue?vue&type=script&lang=ts"
import style0 from "./WebsitePublicPlaceListScreen.vue?vue&type=style&index=0&id=a36cca98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36cca98",
  null
  
)

export default component.exports